import { render } from "./ManageDepartments.vue?vue&type=template&id=78aaf024"
import script from "./ManageDepartments.vue?vue&type=script&lang=js"
export * from "./ManageDepartments.vue?vue&type=script&lang=js"

import "./ManageDepartments.vue?vue&type=style&index=0&id=78aaf024&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__